  <div class="action-panel-main">
    <snl-action-panel class="pt-24" *ngIf="!Scrubber.isSkelton">
      <div left-side class="CommonFiltersPanel df-c">
        <div class="ResetFiltersTxt body-b fw-700 df-c justify-content-start col-gap-16">
          <div class="sektion-filter" *ngIf="Scrubber.isSkelton">
            <span class="Skelton-pp"></span>
          </div>
          <span class="color__primary section-title" *ngIf="!Scrubber.isSkelton">Filter(s)</span>
          <a *ngIf="!Scrubber.isSkelton" href="javascript:void(0);" [ngClass]="{'active': resetActivate() == true}"
            class="ResetAllTxt resetAllFlTxt section-title" (click)="resetAll()">Reset all</a>
        </div>
        <div class="dropdown-col _TextFltr _TextSubPool" *ngIf="!Scrubber.isSkelton">
          <snl-dropdown [label]="'Pool'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
            [options]="Scrubber.subpool" [preSelectedItems]="subPools" (selectedValues)="selectedValues($event,'subpool')"
            (resetDropdown)="resetDropdown($event,'subpool')" [multiple]="true"></snl-dropdown>
        </div>
        <div class="dropdown-col _TextFltr _TextShipOwner " *ngIf="!Scrubber.isSkelton">
          <snl-dropdown [label]="'Ship owner'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
            [options]="Scrubber.shipOwners" [preSelectedItems]="shipOwners"
            (selectedValues)="selectedValues($event,'shipOwners')" (resetDropdown)="resetDropdown($event,'shipOwners')"
            [multiple]="true"></snl-dropdown>
        </div>
        <div class="dropdown-col _TextFltr _TextShipClass" *ngIf="!Scrubber.isSkelton">
          <snl-dropdown [label]="'Ship class'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
            [options]="Scrubber.vslClass" [preSelectedItems]="vslClasses"
            (selectedValues)="selectedValues($event,'vslClass')" (resetDropdown)="resetDropdown($event,'vslClass')"
            [multiple]="true"></snl-dropdown>
        </div>
        <div class="dropdown-col _TextFltr _TextShip" *ngIf="!Scrubber.isSkelton">
          <snl-dropdown [label]="'Ship'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'" [options]="Scrubber.ship"
            [preSelectedItems]="shipNames" (selectedValues)="selectedValues($event,'ship')"
            (resetDropdown)="resetDropdown($event,'ship')" [multiple]="true"></snl-dropdown>
        </div>
      </div>
      <div right-side >
        <div class="monthlyYearlylables">
          <snl-button-toggle (onChange)="getYtdMonthlyVal($event)" [labels]="['YTD','Monthly']" [alignment]="'horizontal'"
            [defaultActive]="defaultActive"></snl-button-toggle>
        </div>  
      </div>
    </snl-action-panel>
    <div class="Skelton-section" *ngIf="Scrubber.isSkelton">
      <div class="sektion-filter"><span class="Skelton-pp"></span></div>
      <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
      <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
      <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
      <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
    </div>
  </div>
  
  <div class="bunkerPricesection" *ngIf="getScrubberTotaldata.length > 0">
    <span class="section-title avgBunkerPrice"  (click)="viewBunkerPriceScrubber()">View average bunker prices as of {{monthToShow }} {{yearToShow}}</span>
    <div class="totalCost">
      <div class="body-b">
        <div class="d-flex">
          Total scrubber savings ($)
          <snl-tooltip position="bottom" [config]="config">
            <figure>
              <img src="assets/img/Info.svg" alt="img">
            </figure>
            <div tooltipContent class="tooltip-padding">
              <div class="body-b">
                <app-static-data *ngIf="sidePanelScrubberData?.bunkerConsumptionMultipliers?.length" [totalScrubberSavings]="true" [bunkerConsMultiLSF]="sidePanelScrubberData?.bunkerConsumptionMultipliers[0]?.LSF" [bunkerConsMultiMGO]="sidePanelScrubberData?.bunkerConsumptionMultipliers[0]?.MGO" [forTooltip]="true"></app-static-data>
              </div>
            </div>
          </snl-tooltip>
        </div>
        <span class="section-title">{{ (toggleVal === 'YTD' ? getScrubberTotaldata[0]?.scrubberSavings : getScrubberTotaldata[0]?.scrubberSavingsMonthly) | negativeToBracket }}</span>
      </div>
      <div class="body-b totalIfo">
        <div class="d-flex">
          Total IFO consumption (MT)
          <snl-tooltip position="bottom" [config]="config">
            <figure>
              <img src="assets/img/Info.svg" alt="img">
            </figure>
            <div tooltipContent class="tooltip-padding">
              <div class="body-b">
                <app-static-data [totalIfoConsumption]="true" [forTooltip]="true"></app-static-data>
              </div>
            </div>
          </snl-tooltip>
        </div>
        <span class="section-title">{{(toggleVal === 'YTD' ? getScrubberTotaldata[0]?.totalIFOConsumptionYTD : getScrubberTotaldata[0]?.totalIFOConsumption) | negativeToBracket}}</span>
      </div>
      <div class="body-b totalIfo">
        <div class="d-flex">
          Total IFO cost ($)
          <snl-tooltip position="bottom" [config]="config">
            <figure>
              <img src="assets/img/Info.svg" alt="img">
            </figure>
            <div tooltipContent class="tooltip-padding">
              <div class="body-b">
                <app-static-data [totalIfoCost]="true" [forTooltip]="true"></app-static-data>
              </div>
            </div>
          </snl-tooltip>
        </div>
        <span class="section-title">{{(toggleVal === 'YTD' ? getScrubberTotaldata[0]?.totalIFOCostYTD : getScrubberTotaldata[0]?.totalIFOCost) | negativeToBracket}}</span>
      </div>
      <div class="viewDetails">
        <span class="section-title" (click)="getCalculationEvent()">View breakdown</span>
      </div>
    </div>
  </div> 
  
  <div class="TableWrapper scroll thin-scroll-x scrubberTable">
    <snl-table [useTopScroll]="false" [disableVerticalScroll]="true" class="expandable-table">
      <snl-row class="headerRow"  [ngClass]="isScrolled ? 'scrolledDown' : ''">
        <snl-th class="scrubberHeaderCol shipOwnerName">Ship / Ship owner / Pool</snl-th>
        <snl-th class="scrubberHeaderCol">Scrubber days</snl-th>
        <snl-th class="scrubberHeaderCol">Scrubber points</snl-th>
        <snl-th class="scrubberHeaderCol scrubberSavings">
          <div>
            Scrubber savings ($) <br/>
            <snl-tooltip position="bottom" [config]="config" class="f-right">
              <span>
                <figure>
                  <img src="assets/img/Info.svg" alt="img">
                </figure>
              </span>
              <div tooltipContent class="tooltip-padding">
                <div class="body-b">
                  <app-static-data [scrubberSavings]="true" [forTooltip]="true"></app-static-data>
                </div>
              </div>
            </snl-tooltip>
          </div>
        </snl-th>
      </snl-row>
      <snl-row class="distance-row" *ngFor="let scrubberData of getScrubberDatalist">
        <snl-td class="shipNameOWner">
          <span class="shipName section-title scrubber-shipname addColor" *ngIf="scrubberData?.canSeeShipLevelCalculation" (click)="scrubberCalevent(scrubberData)">{{scrubberData?.vslName}}</span>
          <span class="shipName section-title scrubber-shipname" *ngIf="!scrubberData?.canSeeShipLevelCalculation">{{scrubberData?.vslName}}</span><br>          
          <span class="shipOwner body-b3">{{ownersLabel[scrubberData?.vslOwner]}}/</span>
          <span class="shipSubpool body-b3">{{scrubberData?.subPool}}</span>
        </snl-td>
        <snl-td>
          <ng-container *ngIf="toggleVal === 'Monthly'">
             <span [ngClass]="scrubberData?.scrubberFailureinCurrentMonth ? 'addErrorcolor' : ''">
              <figure>
                <img *ngIf="scrubberData?.scrubberFailureinCurrentMonth" src="assets/img/Warning.svg" alt="img">
                  <span class="body-b1" *ngIf="scrubberData?.scrubberFailureinCurrentMonth" (click)="scrubberFailureEvent(scrubberData,true)">{{scrubberData?.scbrDays | negativeToBracket}}</span>
                  <span class="body-b1" *ngIf="!scrubberData?.scrubberFailureinCurrentMonth">{{scrubberData?.scbrDays | negativeToBracket}}</span>
              </figure>
             </span>       
          </ng-container>
          <ng-container *ngIf="toggleVal === 'YTD'">
             <span [ngClass]="[scrubberData?.scrubberFailureinCurrentMonth ? 'addErrorcolor' : '',
             scrubberData?.scrubberFailureinPreviousMonth ? 'addColor' : '']">
               <figure>
                <img *ngIf="scrubberData?.scrubberFailureinCurrentMonth" src="assets/img/Warning.svg" alt="img">
                <span class="body-b1 s2"
                 *ngIf="scrubberData?.scrubberFailureinCurrentMonth || scrubberData?.scrubberFailureinPreviousMonth"
                 (click)="scrubberFailureEvent(scrubberData,true)">
                  {{scrubberData?.scbrDaysYTD | negativeToBracket}}</span>
                <span class="body-b1 ss" 
                *ngIf="!scrubberData?.scrubberFailureinCurrentMonth &&  !scrubberData?.scrubberFailureinPreviousMonth">
                  {{scrubberData?.scbrDaysYTD | negativeToBracket}}</span>
              </figure>    
             </span>   
          </ng-container>
        </snl-td>
        <snl-td>
           <ng-container *ngIf="toggleVal === 'Monthly'">
             <span [ngClass]="scrubberData?.scrubberPointCurrentMonth ? 'addErrorcolor' : ''">
              <figure>
                <img *ngIf="scrubberData?.scrubberPointCurrentMonth" src="assets/img/Warning.svg" alt="img">
                  <span class="body-b1" *ngIf="scrubberData?.scrubberPointCurrentMonth" (click)="scrubberFailureEvent(scrubberData,false)">{{scrubberData?.scbrPoints | negativeToBracket}}</span>
                  <span class="body-b1" *ngIf="!scrubberData?.scrubberPointCurrentMonth">{{scrubberData?.scbrPoints | negativeToBracket}}</span>
              </figure>
             </span>       
          </ng-container>
          <ng-container *ngIf="toggleVal === 'YTD'">
             <span [ngClass]="[scrubberData?.scrubberPointCurrentMonth ? 'addErrorcolor' : '',
             scrubberData?.scrubberPointPreviousMonth ? 'addColor' : '']">
               <figure>
                <img *ngIf="scrubberData?.scrubberPointCurrentMonth" src="assets/img/Warning.svg" alt="img">
                <span class="body-b1"
                 *ngIf="scrubberData?.scrubberPointCurrentMonth || scrubberData?.scrubberPointPreviousMonth"
                 (click)="scrubberFailureEvent(scrubberData,false)">
                  {{scrubberData?.scbrPoints | negativeToBracket}}</span>
                <span class="body-b1" 
                *ngIf="!scrubberData?.scrubberPointCurrentMonth &&  !scrubberData?.scrubberPointPreviousMonth">
                  {{scrubberData?.scbrPoints | negativeToBracket}}</span>
              </figure>    
             </span>   
          </ng-container>
        </snl-td>
        <snl-td>
          <span class="body-b1">
            {{toggleVal === 'YTD' ? (scrubberData?.scbrSavingsAmtYTD | negativeToBracket) : (scrubberData?.scbrSavingsAmt | negativeToBracket)}}
          </span>
        </snl-td>
      </snl-row>
    </snl-table>
  </div>

  <snl-side-panel panelType="close" [headerName]="calculationSidePanelHeaderName"  size="large" [(isOpen)]="isCalculationOpen">
    <div sidePanelContent class="largeSidepanelWidth">
      <app-scrubber-calculation *ngIf=" sidePanelScrubberData?.poolLevelScrubberSavings?.length" [calculationResponse]="getScrubberTotaldata"  [sidePanelScrubberData] = "sidePanelScrubberData" [toggleVal]="toggleVal" [viewDetailsSidePanel]="viewDetailsSidePanel"></app-scrubber-calculation>
    </div>
    <div sidePanelFooterContent>
        <snl-button type="primary" size="large" (click)="isCalculationOpen = false">Close</snl-button>
    </div>
  </snl-side-panel>

  <snl-side-panel panelType="close" [headerName]="scrubberShipSidePanelHeaderName"  size="large" [(isOpen)]="isScrubberShipFormula">
    <div sidePanelContent class="largeSidepanelWidth">
      <app-scrubber-calculation *ngIf="scrubberShipSidePanelData?.data?.length"   [sidePanelScrubberShipData] = "scrubberShipSidePanelData" [toggleVal]="toggleVal" [shipSidePanel]="shipSidePanel"></app-scrubber-calculation>
    </div>
    <div sidePanelFooterContent>
        <snl-button class="closeBtn" type="primary" size="large" (click)="isScrubberShipFormula = false">Close</snl-button>
    </div>
  </snl-side-panel>
 
   <!-- scrubber days modal pop up -->

  <div *ngIf="scrubberDaysTableData?.length">
    <snl-modal (click)="scrubberDaysModal = false" [type]="'large'" [open]="scrubberDaysModal">
        <div slot="heading" class="ppLargeModalHeading"> {{scrubberFailureShipName}} scrubber days - scrubber failure details</div>
        <div slot="modalContent" class="modal-content">
            <app-dynamic-table *ngIf="scrubberDaysTableData?.length" [columnHeader]="scrubberDaysColumnHeader"
                [scrubberDaysTableData]="scrubberDaysTableData" [poolPointsTable]="false"
                [scrubberDays]="true"></app-dynamic-table>
        </div>
        <div slot="modalFooter">
            <snl-button size="large" (click)="scrubberDaysModal = false">Close</snl-button>
        </div>
    </snl-modal>
  </div>

  <div *ngIf="scrubberPoolPointTableData?.length">
    <snl-modal (click)="scrubberPoolPointsModal = false" [type]="'large'" [open]="scrubberPoolPointsModal">
        <div slot="heading" class="ppLargeModalHeading"> {{scrubberFailureShipName}} scrubber point update</div>
        <div slot="modalContent" class="modal-content">
            <app-dynamic-table *ngIf="scrubberPoolPointTableData?.length"
              [columnHeader]="scrubberPoolPointColumnHeader"
              [scrubberPoolPointTableData]="scrubberPoolPointTableData"
              [scrubberPoolPoints]="true">
            </app-dynamic-table>
        </div>
        <div slot="modalFooter">
            <snl-button size="large" (click)="scrubberPoolPointsModal = false">Close</snl-button>
        </div>
    </snl-modal>
  </div>

  <snl-side-panel panelType="close" [headerName]="bunkerPriceHeaderName"  size="large" [(isOpen)]="isBunkerSectionOpen">
  <div sidePanelContent class="largeSidepanelWidth">
    <!-- <app-scrubber-calculation *ngIf="sidePanelScrubberData?.poolLevelScrubberSavings?.length" [calculationResponse]="getScrubberTotaldata"  [sidePanelScrubberData] = "sidePanelScrubberData" [toggleVal]="toggleVal" [viewDetailsSidePanel]="viewDetailsSidePanel"></app-scrubber-calculation> -->
    <snl-table *ngFor="let items of groupedByFiscalYear " class="lng-sidepanel-table">
      <snl-row class="lngmodal-thRowHeight">
        <snl-th >{{items[0]}}</snl-th>
        <snl-th class="lngcol scrubberCol">LSF cost ($)</snl-th>
        <snl-th class="lngcol scrubberCol">MGO cost ($)</snl-th>
      </snl-row>
      <snl-row *ngFor="let data of items[1]">
        <snl-td class="showMonth">
            <span class="section-title">{{data.month}}</span>
        </snl-td>
        <snl-td class="lngcol">
            {{data.LSFCost | negativeToBracket}}
        </snl-td>
        <snl-td class="lngcol">
            {{data.MGOCost | negativeToBracket}}
        </snl-td>
      </snl-row>
    </snl-table>
  </div>
  <div sidePanelFooterContent>
      <snl-button type="primary" size="large" (click)="isBunkerSectionOpen = false">Close</snl-button>
  </div>
</snl-side-panel>